export const formatAddress = (address: string): string =>
  `${address.substring(0, 6)}...${address.substring(address.length - 4, address.length)}`;

export const parseAddress = (address: string): string =>
  `0x${address.substring(26, address.length)}`;

export const parseData = (data: string): string =>
  `0x${data.substring(data.length - 40, data.length)}`;